module.exports = __webpack_public_path__ + "static/media/Price6999Ins.138c8020.svg";